import PageLayout from "@/components/feature/PageLayout";
import PageHero from "@/components/feature/PageHero";
import PageCTA from "@/components/feature/PageCTA";
import Breadcrumb from "@/components/feature/Breadcrumb";
import AnimatedSection from "@/components/AnimatedSection";
import { solutionsPageData } from "@/mocks/solutionsPageData";

export default function SolutionsPage() {
  return (
    <PageLayout>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Solutions" },
        ]}
      />

      <PageHero
        badge={solutionsPageData.hero.badge}
        headline={solutionsPageData.hero.headline}
        subtext={solutionsPageData.hero.subtext}
        primaryCTA={solutionsPageData.hero.primaryCTA}
        secondaryCTA={solutionsPageData.hero.secondaryCTA}
      />

      <section className="py-20 md:py-28 bg-background-50">
        <div className="container-astro">
          <AnimatedSection>
            <div className="text-center mb-14 md:mb-18">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
                Solutions We Offer
              </h2>
              <div className="w-16 h-1 bg-accent-500 rounded-full mx-auto" />
            </div>
          </AnimatedSection>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {solutionsPageData.categories.map((solution, i) => (
              <AnimatedSection key={solution.id} delay={i * 100}>
                <div className="group relative p-6 md:p-7 rounded-2xl bg-background-100 border border-background-200/60 hover:border-accent-300/30 hover:shadow-lg hover:shadow-accent-500/5 transition-all duration-400 card-lift h-full flex flex-col">
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-xl mb-5 text-background-50 transition-all duration-300"
                    style={{ backgroundColor: solution.color }}
                  >
                    <span className="w-6 h-6 flex items-center justify-center">
                      <i className={`${solution.icon} text-xl`} />
                    </span>
                  </div>

                  <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2.5 font-heading">
                    {solution.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-5 flex-grow">
                    {solution.desc}
                  </p>

                  <div className="mb-5">
                    <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-2.5">
                      Includes
                    </p>
                    <ul className="space-y-1.5">
                      {solution.items.map((item) => (
                        <li key={item} className="flex items-center gap-2 text-sm text-foreground-600">
                          <i className="ri-check-line text-xs text-accent-500" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <a
                    href="/contact-us"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-600 hover:text-accent-700 transition-colors btn-arrow-hover group/link mt-auto"
                  >
                    {solution.cta}
                    <i className="ri-arrow-right-line btn-arrow text-xs" />
                  </a>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      <PageCTA
        heading={solutionsPageData.cta.heading}
        text={solutionsPageData.cta.text}
        primaryCTA={solutionsPageData.cta.primaryCTA}
        secondaryCTA={solutionsPageData.cta.secondaryCTA}
      />
    </PageLayout>
  );
}